import type { PaymentFailedPubSubEvent } from "./events/payment-failed.pubsub-event";
import type { PaymentFulfilledPubSubEvent } from "./events/payment-fulfilled.pubsub-event";
import type { PaymentPendingPubSubEvent } from "./events/payment-pending.pubsub-event";
import type { PaymentPingPongPubSubEvent } from "./events/payment-ping-pong.pubsub-event";
import type { PaymentRefundFailedPubSubEvent } from "./events/payment-refund-failed.pubsub-event";
import type { PaymentRefundFulfilledPubSubEvent } from "./events/payment-refund-fulfilled.pubsub-event";
import type { PaymentRefundPendingPubSubEvent } from "./events/payment-refund-pending.pubsub-event";
import {
    paymentPubSubEventNamespace,
    paymentPubSubEventTypeNames,
} from "./payment-pubsub-event-type-name";

type PaymentPubSubEvent =
    | PaymentFulfilledPubSubEvent
    | PaymentPendingPubSubEvent
    | PaymentFailedPubSubEvent
    | PaymentRefundFulfilledPubSubEvent
    | PaymentRefundPendingPubSubEvent
    | PaymentRefundFailedPubSubEvent
    | PaymentPingPongPubSubEvent;

type PaymentPubSubEventType = PaymentPubSubEvent["type"];

const paymentPubSubEventTypes = paymentPubSubEventTypeNames.map(
    name => `${paymentPubSubEventNamespace}:${name}`,
) as PaymentPubSubEventType[];

export { paymentPubSubEventTypes };
export type { PaymentPubSubEvent, PaymentPubSubEventType };
